import { Component, EventEmitter, Input, OnInit, Output, ViewChild, ViewContainerRef } from '@angular/core';
import { DevExDropDownComponent } from '../../../devExtreme/src/devExDropDown/devExDropDown.component';
import { MatSelectComponent } from '../../../material/src/matSelect/matSelect.component';
import { ComponentStyle, IAbcComponent, StylingMode } from '../abcComponent.model';
import { AbcComponentService } from '../abcComponent.service';
import { ComboBoxValidationStatus, ICombobox, IComboboxStyle } from './abcCbxGrid';

@Component({
  selector: 'abcCombobox',
  template: '<ng-template #abcCombobox></ng-template>',
})
export class AbcComboboxComponent implements IAbcComponent, OnInit {
  private _value: string;
  @ViewChild('abcCombobox', { static: true, read: ViewContainerRef }) viewContainerRef: ViewContainerRef;
  @Input('id') attrId: string;
  @Input('caption') attrCaption: string;
  @Input() style: ComponentStyle;
  @Input() hoverDropDown: boolean;
  @Input() gridData: any;
  @Input() showClearButton: boolean;
  @Input() deferRendering: boolean;
  @Input() gridHeight: string | number;
  @Input() showGridFilterRow: boolean;
  @Input() isFilterPanelEnabled: boolean;
  private _allowColumnResizing: boolean;
  public isEditable: boolean = false;

  // Used to swap between grid style (JqGrid Or DevExGrid) into mat-select
  @Input() materialGridStyle: ComponentStyle = 2;
  @Output() onOpen = new EventEmitter();
  @Output() onChange = new EventEmitter();
  @Output() onOpened = new EventEmitter();
  @Output() onValueChange = new EventEmitter();
  private _displayExpr;
  private _visible: boolean;
  private _disabled: boolean;
  private _hoverStateEnabled: boolean;
  private _isValid: boolean;
  private _placeholder: string;
  private _readOnly: boolean;
  private _class: string;
  private _width: string;
  private _height: string;
  private _internalId: string;
  private _validationStatus: ComboBoxValidationStatus;
  private _stylingMode: StylingMode;
  private _rtlEnabled: boolean;
  private _showColumnHeader: boolean = true;
  private _enableToolTip: boolean;
  private _maxHeight: string;

  @Input()
  public get allowColumnResizing(): boolean {
    return this._allowColumnResizing;
  }
  public set allowColumnResizing(value: boolean) {
    if (this.componentRef) {
      this.componentRef.allowColumnResizing = value;
    }
    this._allowColumnResizing = value;
  }
  @Input()
  get displayExpr(): any {
    return this._displayExpr;
  }
  set displayExpr(val) {
    this._displayExpr = val;
  }
  public getComponnetRef() {
    return this.componentRef;
  }
  private componentRef;
  get id(): string {
    return this.componentRef.id;
  }
  htmlAttributes: ICombobox;
  comboboxStyle: IComboboxStyle;
  data = [];
  set value(value: any) {
    if (this.componentRef) {
      this.componentRef.value = value;
      this.componentRef.selectedValue = value;
    }
    this._value = value;
  }
  @Input()
  get value() {
    return this._value;
  }

  @Input()
  get width() {
    return this._width;
  }
  set width(data) {
    if (this.componentRef) {
      this.componentRef.width = data;
    }
    this._width = data;
  }

  @Input()
  get maxHeight() {
    return this._maxHeight;
  }
  set maxHeight(data) {
    if (this.componentRef) {
      this.componentRef.maxHeight = data;
    }
    this._maxHeight = data;
  }

  @Input()
  get enableToolTip() {
    return this._enableToolTip;
  }
  set enableToolTip(data) {
    if (this.componentRef) {
      this.componentRef.enableToolTip = data;
    }
    this._enableToolTip = data;
  }

  @Input()
  get height() {
    return this._height;
  }
  set height(data) {
    if (this.componentRef) {
      this.componentRef.height = data;
    }
    this._height = data;
  }

  private _dataSource: any[];
  @Input('dataSource')
  get dataSource() {
    return this._dataSource;
  }
  set dataSource(data) {
    if (this.componentRef) {
      this.componentRef.dataSource = data;
      this.componentRef.gridData = data;
    }
    this._dataSource = data;
  }

  @Input()
  get hoverStateEnabled() {
    return this._hoverStateEnabled;
  }
  set hoverStateEnabled(data) {
    if (this.componentRef) {
      this.componentRef.hoverStateEnabled = data;
    }
    this._hoverStateEnabled = data;
  }

  @Input()
  get visible() {
    return this._visible;
  }
  set visible(data) {
    if (this.componentRef) {
      this.componentRef.visible = data;
    }
    this._visible = data;
  }

  @Input()
  get validationStatus() {
    return this._validationStatus;
  }
  set validationStatus(data) {
    if (this.componentRef) {
      this.componentRef.validationStatus = data;
    }
    this._validationStatus = data;
  }

  @Input()
  get disabled() {
    return this._disabled;
  }
  set disabled(data) {
    if (this.componentRef) {
      this.componentRef.disabled = data;
    }
    this._disabled = data;
  }

  @Input()
  get placeholder() {
    return this._placeholder;
  }
  set placeholder(data) {
    if (this.componentRef) {
      this.componentRef.placeholder = data;
    }
    this._placeholder = data;
  }

  @Input()
  get isValid() {
    return this._isValid;
  }
  set isValid(data) {
    if (this.componentRef) {
      this.componentRef.isValid = data;
    }
    this._isValid = data;
  }

  @Input()
  get readOnly() {
    return this._readOnly;
  }
  set readOnly(data) {
    if (this.componentRef) {
      this.componentRef.readOnly = data;
    }
    this._readOnly = data;
  }

  @Input()
  get internalId() {
    return this._internalId;
  }
  set internalId(data) {
    if (this.componentRef) {
      this.componentRef.internalId = data;
    }
    this._internalId = data;
  }

  @Input()
  get showColumnHeader() {
    return this._showColumnHeader;
  }
  set showColumnHeader(value: boolean) {
    if (this.componentRef) {
      this.componentRef.showColumnHeader = value;
    }
    this._showColumnHeader = value;
  }

  @Input()
  get class() {
    return this._class;
  }
  set class(data) {
    if (this.componentRef) {
      this.componentRef.class = data;
    }
    this._class = data;
  }

  @Input()
  get stylingMode() {
    return this._stylingMode;
  }
  set stylingMode(data) {
    if (this.componentRef) {
      this.componentRef.stylingMode = data;
    }
    this._stylingMode = data;
  }

  @Input()
  get rtlEnabled() {
    return this._rtlEnabled;
  }
  set rtlEnabled(data) {
    if (this.componentRef) {
      this.componentRef.rtlEnabled = data;
    }
    this._rtlEnabled = data;
  }

  datafields = [
    { name: 'id', type: 'string' },
    { name: 'name', type: 'string' },
  ];
  source = {
    datatype: 'json',
    datafields: this.datafields,
    localdata: this.data,
  };
  columns = [
    { text: 'ID', datafield: 'id' },
    { text: 'Name', datafield: 'name' },
  ];

  private _attrLabel: string;
  @Input('label')
  get attrLabel(): string {
    return this._attrLabel;
  }
  set attrLabel(label: string) {
    if (this.componentRef) {
      this.componentRef.label = label;
    }
    this._attrLabel = label;
  }
  dataAdapter: any = this.source;
  private _valueExpr: string;
  @Input()
  get valueExpr(): string {
    return this._valueExpr;
  }
  set valueExpr(key: string) {
    if (this.componentRef) {
      this.componentRef.valueExpr = key;
    }
    this._valueExpr = key;
  }

  constructor(private abcComponentService: AbcComponentService) {
    this._stylingMode = this.abcComponentService.stylingMode;
    this._rtlEnabled = this.abcComponentService.rtlEnabled;
  }
  ngOnInit(): void {
    this.setComboboxAttributesIfAvailable();
    switch (this.style) {
      case ComponentStyle.Material: {
        this.componentRef = <MatSelectComponent>(
          this.abcComponentService.loadComponent(MatSelectComponent, this.viewContainerRef).componentRef.instance
        );
        this.componentRef.materialGridStyle = this.materialGridStyle;
        //do specific stuff for Material
        break;
      }
      case ComponentStyle.DevExpress: {
        this.componentRef = this.abcComponentService.loadComponent(
          DevExDropDownComponent,
          this.viewContainerRef
        ).componentRef.instance;
        //do specific stuff for DevExpress
        break;
      }
    }
    this.componentRef.label = this.attrLabel;
    this.componentRef.datafields = this.datafields;
    this.componentRef.source = this.source;
    this.componentRef.dataSource = this.dataSource;
    this.componentRef.disabled = this.disabled;
    this.componentRef.placeholder = this.placeholder;
    this.componentRef.readOnly = this.readOnly;
    this.componentRef.class = this.class;
    this.componentRef.width = this.width;
    this.componentRef.maxHeight = this.maxHeight ? this.maxHeight : '200px';
    this.componentRef.enableToolTip = this.enableToolTip;
    this.componentRef.height = this.height;
    this.componentRef.visible = this.visible ? this.visible : true;
    this.componentRef.isValid = this.isValid ? this.isValid : true;
    this.componentRef.validationStatus = this.validationStatus ? this.validationStatus : 'valid';
    this.componentRef.hoverStateEnabled = this.hoverStateEnabled;
    this.componentRef.gridData = this.gridData;
    this.componentRef.displayExpr = this.displayExpr;
    this.componentRef.columns = this.columns;
    this.componentRef.caption = this.attrCaption;
    this.componentRef.dataAdapter = this.dataAdapter;
    this.componentRef.id = this.htmlAttributes.id;
    this.componentRef.selectedValue = this.value;
    this.componentRef.hoverDropDown = this.hoverDropDown;
    this.componentRef.showClearButton = this.showClearButton;
    this.componentRef.stylingMode = this.stylingMode ? this.stylingMode : 'outlined';
    this.componentRef.rtlEnabled = this.rtlEnabled ? this.rtlEnabled : false;
    this.componentRef.deferRendering = this.deferRendering;
    this.componentRef.gridHeight = this.gridHeight;
    this.componentRef.showGridFilterRow = this.showGridFilterRow;
    this.componentRef.isFilterPanelEnabled = this.isFilterPanelEnabled;
    this.componentRef.allowColumnResizing = this.allowColumnResizing;
    this.componentRef.showColumnHeader = this.showColumnHeader;
    this.componentRef.isEditable = this.isEditable;
    this.componentRef.setSelectStyle(this.htmlAttributes.setComboboxStyle());
    this.componentRef.valueExpr = this.valueExpr;
    this.componentRef.value = this.value;
    this.onOpen.emit(this.attrId);
    this.onOpen.subscribe(() => {
      this.componentRef.onComboboxOpen(this);
    });
    this.componentRef.onChange.subscribe((event) => {
      this.dataChange(event);
    });
    this.componentRef.onOpened.subscribe((event) => {
      this.opened(event);
    });
    this.componentRef.onValueChange.subscribe((event) => {
      this.valueChange(event);
    });
  }

  setComboboxAttributesIfAvailable() {
    if (this.attrId) {
      const style: IComboboxStyle = {
        height: this.comboboxStyle ? this.comboboxStyle.height : 25,
        width: this.comboboxStyle ? this.comboboxStyle.width : '100%',
      };
      this.htmlAttributes = {
        id: this.attrId,
        caption: this.attrCaption,
        isValid: this.isValid,
        validationStatus: this.validationStatus,
        placeholder: this.placeholder,
        hoverStateEnabled: this.hoverStateEnabled,
        disabled: this.disabled,
        visible: this.visible,
        readOnly: this.readOnly,
        class: this.class,
        stylingMode: this.stylingMode,
        rtlEnabled: this.rtlEnabled,
        value: this.value,
        setComboboxStyle: (_inputStyle) => (_inputStyle = style),
      };
    }
  }

  onComboboxOpen(column, data, displayExpr, valueExpr?, selectedId?) {
    this.componentRef.onComboboxOpen(column, data, displayExpr, valueExpr, selectedId);
  }

  private dataChange(event) {
    this.onChange.emit({ newValue: event?.newValue, value: event?.value });
  }

  private valueChange(event) {
    this.onValueChange.emit({ newValue: event?.newValue, value: event?.value, id: event?.id });
  }

  public opened(event): void {
    this.onOpened.emit(event);
  }
}
